import styled, { css } from 'styled-components'

import { Color } from 'root-constants'

type TWrapperProps = {
  hasNavigation: boolean
  hasProgressBar: boolean
  hasShadow?: boolean
}

type TContainerProps = {
  isVisible: boolean
}

type TThemeProps = {
  applyCoralTheme: boolean
}

const coralWrapperStyles = css`
  height: 52px;
  align-items: center;
  margin-bottom: 0;
  padding: 5px 16px;
`

const defaultWrapperStyles = css`
  height: 40px;
  align-items: flex-end;
`

const defaultPagesContainerStyles = css`
  font-size: 14px;
  line-height: 24px;
  color: ${Color.LIGHT};
  font-weight: 400;

  & > span:not(:last-of-type) {
    margin-right: 4px;
  }
`

const coralPagesContainerStyles = css`
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.5px;

  & > span:first-of-type {
    color: ${Color.CORAL};
  }

  & > span:not(:first-of-type) {
    color: ${Color.BLUE_DARK};
  }
`

export const StyledHeaderMinimalistic = {
  Wrapper: styled.header<TWrapperProps & TThemeProps>`
    width: 100%;
    background-color: ${Color.WHITE};
    padding: 10px 16px 0;
    display: flex;
    position: relative;
    z-index: 3;
    justify-content: ${({ hasNavigation }) =>
      hasNavigation ? 'space-between' : 'center'};
    margin-bottom: ${({ hasProgressBar }) => (hasProgressBar ? '8px' : '16px')};
    ${({ hasShadow, applyCoralTheme }) => {
      if (hasShadow) {
        return css`
          box-shadow: 0 5px 20px #dfe3f3;
          height: 50px;
          align-items: center;
          margin: 0 auto 16px;
          padding: 13px 16px;
        `
      }

      if (applyCoralTheme) {
        return css`
          ${coralWrapperStyles}
        `
      }

      return css`
        ${defaultWrapperStyles}
      `
    }}
  `,
  ArrowIconContainer: styled.div<TContainerProps>`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    min-width: 55px;
    height: 24px;
  `,
  PageNumberContainer: styled.div<TContainerProps & TThemeProps>`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    min-width: 55px;
    text-align: right;

    ${({ applyCoralTheme }) => {
      if (applyCoralTheme) {
        return css`
          ${coralPagesContainerStyles}
        `
      }

      return css`
        ${defaultPagesContainerStyles}
      `
    }}
  `,
}
